import { Currency } from '@seapoint/server/enums';
import euFlag from '../assets/images/flag-eu.svg';
import gbFlag from '../assets/images/flag-gb.svg';
import { SupportedCountryCurrency } from '../types/supported-country-currency';
import { exhaustiveCheck } from './exhaustive-check';

export const getCurrencyFlag = (currency: SupportedCountryCurrency) => {
  switch (currency) {
    case Currency.EUR:
      return euFlag;
    case Currency.GBP:
      return gbFlag;
    default:
      return exhaustiveCheck(currency);
  }
};
